export default $axios => ({
  resource: 'moraine/notification'
})
